import { GetBankAccounts } from "../../services/modules/bank";
import { useFetch } from "./config";
import { isReactSnap } from "../../utils/react-snap";

export function useFetchBankAccounts() {
  return useFetch({
    queryKeys: ["bank-accounts"],
    queryFn: async () => {
      const { resultData } = await GetBankAccounts({ status: "active", payment_type: "deposite" });
      return resultData;
    },
    enabled: !isReactSnap(),
  });
}
